import { useState } from "react";
import { followUpStories } from "@/mocks/chigua";

export default function FollowUp() {
  const [bookmarks, setBookmarks] = useState<number[]>([]);
  const toggle = (id: number) =>
    setBookmarks((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  return (
    <section id="follow" className="relative overflow-hidden bg-background-50 py-14 md:py-20">
      <div className="absolute right-0 top-10 hidden h-72 w-72 -translate-y-1/2 rounded-full bg-primary-100/70 blur-2xl lg:block"></div>
      <div className="relative mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="mb-2 text-xs font-medium tracking-widest text-accent-600">FOLLOW THE STORY</p>
          <h2 className="font-display text-3xl text-foreground-950 md:text-4xl">
            蹲一个<span className="text-accent-600">后续</span>
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
            蹲后续就是持续关注一件事的进展。我们把热门事件的关键节点和时间线整理清楚，
            你只管蹲，剩下的更新交给我们。
          </p>
        </div>

        <div className="mt-9 grid gap-6 lg:grid-cols-3">
          {followUpStories.map((story) => {
            const saved = bookmarks.includes(story.id);
            return (
              <article
                key={story.id}
                className="flex flex-col rounded-3xl border border-background-200 bg-background-100 p-6"
              >
                <div className="flex items-start justify-between gap-3">
                  <span className="rounded-full bg-accent-50 px-3 py-1 text-xs font-medium text-accent-700">
                    {story.status}
                  </span>
                  <button
                    type="button"
                    onClick={() => toggle(story.id)}
                    aria-label={saved ? "取消关注后续" : "关注后续"}
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors ${
                      saved
                        ? "bg-primary-500 text-background-50"
                        : "border border-background-300 text-foreground-400 hover:border-primary-300 hover:text-primary-600"
                    }`}
                  >
                    <i className={saved ? "ri-bookmark-fill" : "ri-bookmark-line"}></i>
                  </button>
                </div>
                <h3 className="mt-4 font-display text-lg leading-snug text-foreground-950">{story.title}</h3>

                <div className="relative mt-5 flex-1">
                  {story.points.map((p, i) => {
                    const isLast = i === story.points.length - 1;
                    return (
                      <div key={i} className="relative pl-8">
                        {!isLast && (
                          <span className="absolute left-[7px] top-6 h-full w-px bg-accent-300"></span>
                        )}
                        <span className="absolute left-0 top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-accent-400 bg-background-50">
                          <span className={`h-1.5 w-1.5 rounded-full ${isLast ? "bg-primary-500" : "bg-accent-400"}`}></span>
                        </span>
                        <p className="pb-5 text-sm leading-relaxed text-foreground-700">{p}</p>
                      </div>
                    );
                  })}
                </div>

                <button
                  type="button"
                  className={`mt-2 inline-flex items-center justify-center gap-2 rounded-full px-4 py-2.5 text-sm font-medium transition-colors ${
                    saved
                      ? "bg-accent-100 text-accent-800 hover:bg-accent-200"
                      : "bg-primary-500 text-background-50 hover:bg-primary-600"
                  }`}
                >
                  <i className={saved ? "ri-check-double-line" : "ri-notification-2-line"}></i>
                  {saved ? "已加入蹲点，更新提醒你" : "蹲这个后续"}
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}